import Helper from '@ember/component/helper';
import PrettyNum from '../utils/pretty-num-wrapper';
import Utils from '../utils/utils';

export default class PrettyNumHelper extends Helper {
    compute(params, hash) {
        /* 
		hash: {
				value:      <number>    Value to get beautified.1
				separate    <?bool>     Separate the multiplier from the value with a space.
				uom         <?string>   Unit of measure.
			}
		*/
        let func = hash.func || 'eng3',
            options = {};

        if (Utils.isNumeric(hash.scale)) options.scale = hash.scale;
        if (hash.separatedUnit) options.separatedUnit = hash.separatedUnit;

        return PrettyNum[func](hash.value, options) + (hash.uom ? hash.uom : '');
    }
}
